export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const NUMBER_REGEXP = /^\d+$/;
export const SORT_CODE_REGEXP = /^\d{2}-\d{2}-\d{2}$/;
export const BANK_ACCOUNT_NUMBER_REGEXP = /^\d{8}$/;
